import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';

@Injectable()
export class CacheHttpInterceptor implements HttpInterceptor {
    constructor(
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        // TODO revise. find a different way of skipping this interceptor when cache rules will be different
        if (
            req.url.startsWith(this._appConfig.API_ENDPOINTS.SCORECARD) ||
            req.url.startsWith(this._appConfig.API_ENDPOINTS.COACHING) ||
            req.url.startsWith(
                `${this._appConfig.API_ENDPOINTS.INSIGHT}/card`,
            ) ||
            req.url.startsWith(
                `${this._appConfig.OAUTH.AUTHORIZATION_ENDPOINT}/connect/token`,
            ) ||
            req.url.startsWith(
                `${this._appConfig.API_ENDPOINTS.WEB_FORMS}/auth`,
            )
        ) {
            return next.handle(req);
        }

        return next.handle(
            req.clone({
                headers: req.headers
                    .set('Pragma', 'no-cache')
                    .set('Cache-Control', 'no-cache, no-store'),
            }),
        );
    }
}
